import { emailNotificationsEpics } from './emailNotifications/emailNotifications.epics';

export const personalSettingsEpics = [...emailNotificationsEpics];
